import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const currentUserAtom = atomWithStorage("rostatv-current-user", null);
export const pageTitleAtom = atom("");
export const showOverlayLoadingAtom = atom(false);
export const socialMediaAtom = atomWithStorage("rostatv-socialMedia", null);
